/**
 * BSS B2B Form Handler
 * Handles conditional visibility of delivery address fields
 */
(function() {
  'use strict';

  var SAME_AS_INVOICE_VALUE = 'Same as invoice address';
  var FIELDS_TO_HIDE = ['Address', 'Suburb / City', 'State', 'Post code'];

  function initDeliveryAddressHandler() {
    var deliveryLabel = document.querySelector('label[title="Delivery Address"]');
    if (!deliveryLabel) return false;

    var labelFor = deliveryLabel.getAttribute('for');
    var deliveryDropdown = labelFor
      ? document.getElementById(labelFor)
      : deliveryLabel.parentElement.querySelector('select');

    if (!deliveryDropdown) return false;

    var dropdownContainer = deliveryDropdown.closest('.bss-b2b-rf-field');
    if (!dropdownContainer) return false;

    var fieldsToToggle = [];
    var sibling = dropdownContainer.nextElementSibling;

    while (sibling) {
      if (sibling.classList.contains('bss-b2b-rf-field')) {
        var label = sibling.querySelector('label');
        var labelText = label ? label.textContent.trim() : '';
        if (FIELDS_TO_HIDE.indexOf(labelText) !== -1) {
          fieldsToToggle.push(sibling);
        }
      }
      sibling = sibling.nextElementSibling;
    }

    if (fieldsToToggle.length === 0) return false;

    function toggleFields() {
      var shouldHide = deliveryDropdown.value === SAME_AS_INVOICE_VALUE;
      fieldsToToggle.forEach(function(field) {
        field.style.display = shouldHide ? 'none' : '';
      });
    }

    toggleFields();
    deliveryDropdown.addEventListener('change', toggleFields);

    return true;
  }

  function waitForForm() {
    if (initDeliveryAddressHandler()) return;

    var observer = new MutationObserver(function() {
      if (initDeliveryAddressHandler()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(function() {
      observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForForm);
  } else {
    waitForForm();
  }
})();
